import {
  replenishmentEnd,
  replenishmentStart,
  fetchCabinet,
  fetchCabinetInventory,
  fetchCabinetStatus,
  startInventoryCorrection,
  sendCalibrationCommand,
} from '../utils/api';
import userManager from '../utils/userManager';
import { showToastMessage } from './common';

export const REPLENISHMENT_START = 'REPLENISHMENT_START';
export const REPLENISHMENT_END = 'REPLENISHMENT_END';
export const REPLENISHMENT_DELAY_OFF = 'REPLENISHMENT_DELAY_OFF';
export const REPLENISHMENT_ERROR = 'REPLENISHMENT_ERROR';
export const REPLENISHMENT_CLEAR_ERROR = 'REPLENISHMENT_CLEAR_ERROR';
export const CABINET_FETCH_START = 'CABINET_FETCH_START';
export const CABINET_FETCH_END = 'CABINET_FETCH_END';
export const CABINET_FETCH_ERROR = 'CABINET_FETCH_ERROR';
export const CABINET_UPDATE = 'CABINET_UPDATE';
export const CABINET_INVENTORY_FETCH_START = 'CABINET_INVENTORY_FETCH_START';
export const CABINET_INVENTORY_FETCH_END = 'CABINET_INVENTORY_FETCH_END';
export const CABINET_INVENTORY_FETCH_ERROR = 'CABINET_INVENTORY_FETCH_ERROR';
export const CABINET_INVENTORY_UPDATE = 'CABINET_INVENTORY_UPDATE';
export const INVENTORY_CORRECTION_START = 'INVENTORY_CORRECTION_START';

export const INVENTORY_CORRECTION_DONE = 'INVENTORY_CORRECTION_DONE';

export const CALIBRATION_START = 'CALIBRATION_START';
export const CALIBRATION_START_ERROR = 'CALIBRATION_START_ERROR';
export const EMPTY_SHELF_START = 'EMPTY_SHELF_START';
export const EMPTY_SHELF_START_ERROR = 'EMPTY_SHELF_START_ERROR';
export const EMPTY_SHELF_END = 'EMPTY_SHELF_END';
export const EMPTY_SHELF_END_ERROR = 'EMPTY_SHELF_END_ERROR';
export const INITIAL_SHELF_SLOT_END = 'INITIAL_SHELF_SLOT_END';
export const INITIAL_SHELF_SLOT_END_ERROR = 'INITIAL_SHELF_SLOT_END_ERROR';
export const CALIBRATION_END = 'CALIBRATION_END';
export const CALIBRATION_END_ERROR = 'CALIBRATION_END_ERROR';
export const INITIAL_SHELF_SLOT_START = 'INITIAL_SHELF_SLOT';
export const INITIAL_SHELF_SLOT_START_ERROR = 'INITAL_SHELF_SLOT_ERROR';
export const CANCEL_SLOT_CALIBRATION = 'CANCEL_SLOT_CALIBRATION';
export const CANCEL_SLOT_CALIBRATION_ERROR = 'CANCEL_SLOT_CALIBRATION_ERROR';
export const RECEIVE_CABINET_SHELF_CONFIG_DATA = 'FETCH_CABINET_SHELF_DATA';

export const CalibrationCommands = {
  startProductTraining: 'startProductTraining',
  emtpyShelfSlotStart: 'emtpyShelfSlotStart',
  emtpyShelfSlotEnd: 'emtpyShelfSlotEnd',
  initialShelfSlotEnd: 'initialShelfSlotEnd',
  stopProductTraining: 'stopProductTraining',
  cancelSlotCalibration: 'cancelEmtpyShelfSlotStart',
};

const STATUS_CHECK_MAX_RETRY =
  process.env.REACT_APP_CABINET_STATUS_CHECK_MAX_RETRY || 6;
const STATUS_CHECK_THRESHOLD =
  process.env.REACT_APP_CABINET_STATUS_CHECK_THRESHOLD || 1500;

const handleDelay = (deviceCode, group, dispatch, nonce = 1) => {
  setTimeout(() => {
    fetchCabinetStatus(deviceCode, group).then(response => {
      if (response?.cabinetState === 'refillStart') {
        dispatch({
          type: REPLENISHMENT_DELAY_OFF,
        });
      } else if (STATUS_CHECK_MAX_RETRY > nonce) {
        handleDelay(deviceCode, group, dispatch, nonce + 1);
      } else {
        showToastMessage('error:cabinetState')(dispatch);

        dispatch({
          type: REPLENISHMENT_DELAY_OFF,
        });
      }
    });
  }, [STATUS_CHECK_THRESHOLD]);
};

export const sendInventoryCorrection = (
  deviceCode,
  group,
  shelf,
  slot,
  productId,
  amount
) => async dispatch => {
  dispatch({
    type: INVENTORY_CORRECTION_START,
  });
  await startInventoryCorrection(
    deviceCode,
    group,
    shelf,
    slot,
    productId,
    amount
  );
  dispatch({
    type: INVENTORY_CORRECTION_DONE,
  });
};

export const startReplenishment = (deviceCode, group) => async dispatch => {
  handleDelay(deviceCode, group, dispatch);

  // Send refill command
  const response = await replenishmentStart(deviceCode);

  if (response.ok) {
    dispatch({
      type: REPLENISHMENT_START,
    });
  } else {
    let error;
    if (response.status === 401) {
      userManager.removeUser();
    } else if (response.status === 403) {
      error = 'error:forbidden';
    } else {
      error = 'error:unknown';
    }

    dispatch({
      type: REPLENISHMENT_ERROR,
      error,
    });

    dispatch({
      type: REPLENISHMENT_DELAY_OFF,
    });
  }
};

export const endReplenishment = deviceCode => async dispatch => {
  try {
    await replenishmentEnd(deviceCode);
    dispatch({
      type: REPLENISHMENT_END,
    });
  } catch (e) {
    dispatch({
      type: REPLENISHMENT_ERROR,
      error: e,
    });
  }
};

const startCabinetFetch = () => ({ type: CABINET_FETCH_START });
const endCabinetFetch = () => ({ type: CABINET_FETCH_END });
const errorCabinetFetch = error => ({ type: CABINET_FETCH_ERROR, error });
const updateCabinetInfo = (
  name,
  deviceCode,
  id,
  organizationId,
  deviceSubType,
  deviceSubTypeName
) => ({
  type: CABINET_UPDATE,
  name,
  deviceCode,
  id,
  organizationId,
  deviceSubType,
  deviceSubTypeName,
});

/**
 * fetch cabinet details for the provided deviceCode
 * @param {*} deviceCode
 * @returns
 */
export const fetchCabinetInfo = deviceCode => async dispatch => {
  try {
    dispatch(startCabinetFetch());

    const body = await fetchCabinet(deviceCode);
    const { name, id, organizationId, subTypeName } = body;
    const subType = subTypeName?.split('_')[3];

    let deviceSubTypeName;

    switch (subType) {
      case 'S1':
        deviceSubTypeName = 'scale';
        break;
      case 'R1S1':
        deviceSubTypeName = 'hybrid';
        break;
      default:
        deviceSubTypeName = 'rfid';
        break;
    }

    dispatch(
      updateCabinetInfo(
        name,
        deviceCode,
        id,
        organizationId,
        subTypeName,
        deviceSubTypeName
      )
    );
    dispatch(endCabinetFetch());
  } catch (e) {
    dispatch(errorCabinetFetch(e));
  }
};

export const clearError = () => ({
  type: REPLENISHMENT_CLEAR_ERROR,
});

const startCabinetInventoryFetch = () => ({
  type: CABINET_INVENTORY_FETCH_START,
});
const endCabinetInventoryFetch = () => ({ type: CABINET_INVENTORY_FETCH_END });
const errorCabinetInventoryFetch = error => ({
  type: CABINET_INVENTORY_FETCH_ERROR,
  error,
});
const updateCabinetInventory = items => ({
  type: CABINET_INVENTORY_UPDATE,
  items,
});

export const handleFetchCabinetInventory = deviceCode => async dispatch => {
  try {
    dispatch(startCabinetInventoryFetch());

    const body = await fetchCabinetInventory(deviceCode);
    const { tags: items } = body;

    dispatch(updateCabinetInventory(items));

    // To prevent too many requests by user
    setTimeout(() => {
      dispatch(endCabinetInventoryFetch());
    }, 600);
  } catch (e) {
    dispatch(errorCabinetInventoryFetch(e));
  }
};

export const startCalibration = (
  deviceCode,
  subType,
  readerType
) => async dispatch => {
  try {
    const command = CalibrationCommands.startProductTraining;
    const params = { subType: subType, readerType: readerType };

    await sendCalibrationCommand(deviceCode, command, params);
    dispatch({ type: CALIBRATION_START });
  } catch (e) {
    dispatch({
      type: CALIBRATION_START_ERROR,
      error: e,
    });
  }
};

export const startEmptyShelf = (deviceCode, shelf, slot) => async dispatch => {
  try {
    const command = CalibrationCommands.emtpyShelfSlotStart;
    const params = { shelf, slot };

    await sendCalibrationCommand(deviceCode, command, params);
    dispatch({ type: EMPTY_SHELF_START });
  } catch (e) {
    dispatch({
      type: EMPTY_SHELF_START_ERROR,
      error: e,
    });
  }
};

export const cancelSlotCalibration = (
  deviceCode,
  shelf,
  slot
) => async dispatch => {
  try {
    const command = CalibrationCommands.cancelSlotCalibration;
    const params = { shelf, slot };

    await sendCalibrationCommand(deviceCode, command, params);
    dispatch({ type: 'CANCEL_SLOT_CALIBRATION' });
  } catch (error) {
    dispatch({ type: 'CANCEL_SLOT_CALIBRATION_ERROR', error });
  }
};

export const endEmptyShelf = (deviceCode, shelf, slot) => async dispatch => {
  try {
    const command = CalibrationCommands.emtpyShelfSlotEnd;
    const params = { shelf, slot };

    await sendCalibrationCommand(deviceCode, command, params);
    dispatch({ type: EMPTY_SHELF_END });
  } catch (e) {
    dispatch({
      type: EMPTY_SHELF_END_ERROR,
      error: e,
    });
  }
};

/**
 * When save button is pressed on the calibration product assignment,
 * a command is sent with the product info to the API
 * @param {*} deviceCode
 * @param {*} shelf
 * @param {*} slot
 * @param {*} productId
 * @param {*} amount
 * @returns
 */
export const initialShelfSlotEnd = (
  deviceCode,
  shelf,
  slot,
  productId,
  amount
) => async dispatch => {
  try {
    const command = CalibrationCommands.initialShelfSlotEnd;
    const params = { deviceCode, shelf, slot, productId, amount };

    return sendCalibrationCommand(deviceCode, command, params).then(() => {
      dispatch({ type: INITIAL_SHELF_SLOT_END });
    });
  } catch (e) {
    dispatch({
      type: INITIAL_SHELF_SLOT_END_ERROR,
      error: e,
    });
  }
};

export const endCalibration = (deviceCode, value) => async dispatch => {
  try {
    const command = CalibrationCommands.stopProductTraining;
    const params = { value };

    await sendCalibrationCommand(deviceCode, command, params);
    dispatch({ type: CALIBRATION_END });
  } catch (e) {
    dispatch({
      type: CALIBRATION_END_ERROR,
      error: e,
    });
  }
};

export const fetchCabinetShelfConfig = () => async dispatch => {
  const url = 'https://cdn.selflystore.com/shelf-configs/shelf-configs.json';
  return fetch(url)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: RECEIVE_CABINET_SHELF_CONFIG_DATA,
        config: data,
      });
    })
    .catch(err => {});
};
